document.addEventListener('DOMContentLoaded', ()=>{
  new Swiper(".SmarterComposition__slider__swiper.swiper", {
    spaceBetween: 40,
    slidesPerView: 'auto',
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      750: {
        spaceBetween: 53
      }      
    }    
  });
})